<template>
<div>
  <div class="content-i">
    <div class="content-box">
      <div class="element-wrapper">
        <h6 class="element-header">Invoicing</h6>
        <div class="element-box">
          <div class="element-info">
            <div class="row align-items-center">
              <div class="col-sm-8">
                <div class="element-info-with-icon">
                  <div class="element-info-icon">
                    <div class="os-icon os-icon-file">
                    </div>
                  </div>
                  <div class="element-info-text">
                    <h5 class="element-inner-header">Invoicing Track</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 mb-2">
              {{invoicingBatchesCount}} invoicing {{ invoicingBatchesCount === 1 ? "batch" : "batches" }}
            </div>
            <div class="input-group col-lg-2 col-md-4 col-sm-12 mb-2 mb-md-0">
                <div class="input-group-prepend">
                  <div class="input-group-text">
                      {{ t('recordsPerPageText','recordsPerPageText') }}
                  </div>
                </div>
                <input class="form-control" type="number" min="1" v-model="perPage" :placeholder="perPage" @change="onPerPageChange">
            </div>
          </div>
          <hr>
          <b-table id="invoicing-batches-table" striped hover bordered :fields="fields" :busy.sync="loading" :items="invoicingBatches" :currentPage="currentPage" :filter="filter" @filtered="onFiltered" :show-empty="true">
            <template class="busy-row" slot="table-busy" slot-scope="items" v-bind:value="invoicingBatches">
              <vcl-table :rows="1" :columns="6"></vcl-table>
            </template>

            <template v-slot:cell(reference)="data" >
              <router-link :to="{ name: 'documents_search', query: { page: 1, per_page: 20, batch: data.item.batch.id }}">{{data.item.batch.reference}}</router-link>
            </template>

            <template v-slot:cell(name)="data">{{data.item.name}}</template>

            <template v-slot:cell(total_docs)="data" >
              <span type="text" class="text-capitalize"> {{ data.item.total_docs }} ({{data.item.total_pages}})</span>
            </template>

            <template v-slot:cell(deleted_docs)="data" >
              <span type="text" class="text-capitalize"> {{ data.item.deleted_docs }} ({{data.item.deleted_pages}})</span>
            </template>

            <template v-slot:cell(added_on)="data" >
              <span type="text" class="text-capitalize"> {{ data.item.added_on | asDate }}</span>
            </template>

            <template v-slot:cell(date)="data" >
              <span type="text" class="text-capitalize"> {{ data.item.date | asDate }}</span>
            </template>

          </b-table>
          <div class="row">
            <div class="offset-md-8 col-md-4 offset-lg-8 col-lg-4 mb-2 mb-md-0">
                <p>&nbsp;</p>
                <b-pagination class="float-right mb-0" v-model="currentPage" @input="onPerPageChange" :per-page="perPage" :total-rows="invoicingBatchesCount" aria-controls="track-invoices-table" v-if="invoicingBatchesCount > perPage"></b-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import 'bootstrap-vue/dist/bootstrap-vue.css'
import { VclTable } from 'vue-content-loading'

export default {
    name: 'InvoicingTrack',
    components:{
        VclTable
    },
    data () {
      return {
          fields: [
              {key: 'reference', label: 'Batch Reference', sortable: true, thClass: 'hover-pointer brand-color'},
              {key: 'name', label: 'Batch Type', sortable: true, thClass: 'hover-pointer brand-color'},
              {key: 'total_docs', label: 'Total Docs (P)', sortable: true, thClass: 'hover-pointer brand-color'},
              {key: 'deleted_docs', label: 'Deleted (P)', sortable: true, thClass: 'hover-pointer brand-color'},
              {key: 'added_on', label: 'Added On', sortable: true, thClass: 'hover-pointer brand-color'},
              {key: 'date', label: 'Processed', sortable: true, thClass: 'hover-pointer brand-color'},
          ],
          currentPage: 1,
          perPage: 20,
          filter: null,
          loading: false
      }
    },
    methods: {
      onFiltered(filteredItems) {
          this.totalRows = filteredItems.length
          this.currentPage = 1
      },
      loadInvoicingBatches() {
        this.loading = true
        this.$store.dispatch('loadInvoicingBatches', {
          start: (this.currentPage * this.perPage) - this.perPage,
          perPage: this.perPage,
          isTester: this.$store.getters.getUserDetails.is_tester,
        }).finally(() => {
          this.loading = false
        })
      },
      onPerPageChange() {
        if (this.perPage < 1) {
          this.perPage = 1;
        }
        this.loadInvoicingBatches()
      },
      goToDocumentsSearch(batch_id) {
        this.loading = true;
        this.$router.push({ name: 'documents_search', query: { batch: batch_id } }, () => { this.loading = false; }, (err) => {
          console.error(err);
          this.loading = false;
        })
      }
    },
    computed:{
      invoicingBatches: {
        get() {
          return this.$store.getters.getInvoicingBatches
        }
      },
      invoicingBatchesCount: {
        get() {
          return this.$store.getters.getInvoicingBatchesCount
        }
      },
    },
    created() {
        this.loadInvoicingBatches()
    },
}

</script>

<style scoped>
  table >>> tbody, table >>> thead{
    text-align: center;
  }
  .table  >>> .brand-color {
    background-color: #047bf8 !important;
    color: white !important;
  }
</style>
